<template>
   
        <md-list class="divInfo md-double-line semMargin">
            <md-list-item>
                <div v-bind:class="'md-list-item-text border semMargin borderColor-' + (bordaCor || 'default')">
                    <span class="info s-h1" v-if="tipo == 'texto'">{{informacao}}</span>
                    <span class="info s-h1" v-if="tipo == 'moeda'" v-formatmoeda="informacao"></span>
                    <span class="info s-h1" v-if="tipo == 'date'" v-formatdate="informacao"></span>
                    <span class="info s-h1" v-if="tipo == 'dataTime'" v-formatdatetime="informacao"></span>
                    <span class="descricao" >{{descricao}}</span>
                </div>
            </md-list-item>
        </md-list>
   
</template>

<script>
    import { formatdatetime } from '@/directives/formatdatetime.js';
    import { formatdate } from '@/directives/formatdate.js';
    import { formatmoeda } from '@/directives/formatmoeda.js';

    export default {
        directives: {
            formatdatetime,
            formatdate,
            formatmoeda
        },
        props: {
            Informacao: String,
            Descricao: String,
            BordaCor: String,
            Tipo: String
        },
        data:
            function () {
                return {
                    informacao: this.Informacao,
                    descricao: this.Descricao,
                    bordaCor: this.BordaCor,
                    tipo: this.Tipo
                }
            }
    }
</script>

<style scoped>
    .border {
        border-left: solid 5px;
        border-radius: 5px;
    }

    .borderColor-default {
        border-color: #009688 !important;
    }

    .borderColor-009688 {
        border-color: #009688 !important;
    }

    .borderColor-6361fb {
        border-color: #6361fb !important;
    }

    .borderColor-ffad42 {
        border-color: #ffad42 !important;
    }

     .borderColor-ff0000 {
        border-color: #ff0000 !important;
    }

    .semMargin {
        margin: 0px !important;
        padding: 0px !important;
    }

    .info {
        font-size: 20px;
        font-weight: bold;
        padding-left: 5px;
    }

    .descricao {
        padding-left: 5px;
        padding-top:8px;
    }


    .divInfo {
        width: auto;
        float: left;
        position: relative;
        display: inline;
    }

    .borderColor-transparent
    {
         border-color: transparent !important;
    }

  

</style>
